/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadReturnOutboundInfoVo
 */
export interface UploadReturnOutboundInfoVo {
    /**
     * 退货方式 1 快递 2 货车
     * @type {number}
     * @memberof UploadReturnOutboundInfoVo
     */
    returnTransportMethod?: number;
    /**
     * 退货编码（快递退货时必填）
     * @type {string}
     * @memberof UploadReturnOutboundInfoVo
     */
    returnCode?: string;
    /**
     * 退货出库日期（快递退货时必填）
     * @type {string}
     * @memberof UploadReturnOutboundInfoVo
     */
    returnOutboundDate?: string;
    /**
     * 车牌号（货车退货时必填）
     * @type {string}
     * @memberof UploadReturnOutboundInfoVo
     */
    returnTruckNumber?: string;
    /**
     * 联系方式（货车退货时必填）
     * @type {string}
     * @memberof UploadReturnOutboundInfoVo
     */
    returnTruckContact?: string;
    /**
     * 代买费用退款 true 是 false 否
     * @type {boolean}
     * @memberof UploadReturnOutboundInfoVo
     */
    returnPurchaseFee?: boolean;
}

/**
 * Check if a given object implements the UploadReturnOutboundInfoVo interface.
 */
export function instanceOfUploadReturnOutboundInfoVo(value: object): value is UploadReturnOutboundInfoVo {
    return true;
}

export function UploadReturnOutboundInfoVoFromJSON(json: any): UploadReturnOutboundInfoVo {
    return UploadReturnOutboundInfoVoFromJSONTyped(json, false);
}

export function UploadReturnOutboundInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadReturnOutboundInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'returnTransportMethod': json['returnTransportMethod'] == null ? undefined : json['returnTransportMethod'],
        'returnCode': json['returnCode'] == null ? undefined : json['returnCode'],
        'returnOutboundDate': json['returnOutboundDate'] == null ? undefined : json['returnOutboundDate'],
        'returnTruckNumber': json['returnTruckNumber'] == null ? undefined : json['returnTruckNumber'],
        'returnTruckContact': json['returnTruckContact'] == null ? undefined : json['returnTruckContact'],
        'returnPurchaseFee': json['returnPurchaseFee'] == null ? undefined : json['returnPurchaseFee'],
    };
}

export function UploadReturnOutboundInfoVoToJSON(json: any): UploadReturnOutboundInfoVo {
    return UploadReturnOutboundInfoVoToJSONTyped(json, false);
}

export function UploadReturnOutboundInfoVoToJSONTyped(value?: UploadReturnOutboundInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'returnTransportMethod': value['returnTransportMethod'],
        'returnCode': value['returnCode'],
        'returnOutboundDate': value['returnOutboundDate'],
        'returnTruckNumber': value['returnTruckNumber'],
        'returnTruckContact': value['returnTruckContact'],
        'returnPurchaseFee': value['returnPurchaseFee'],
    };
}

